import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 自动加载语言模块（webpack5 完美支持）
function loadMessages() {
  const messages = {}

  // 加载中文
  const zhFiles = require.context('./zh', false, /\.json$/)
  messages.zh = {}
  zhFiles.keys().forEach(key => {
    const name = key.replace(/^\.\/(.*)\.json$/, '$1')
    messages.zh[name] = zhFiles(key)
  })

  // 加载英文
  const enFiles = require.context('./en', false, /\.json$/)
  messages.en = {}
  enFiles.keys().forEach(key => {
    const name = key.replace(/^\.\/(.*)\.json$/, '$1')
    messages.en[name] = enFiles(key)
  })

  // 加载泰文
  const thaiFiles = require.context('./thai', false, /\.json$/)
  messages.thai = {}
  thaiFiles.keys().forEach(key => {
    const name = key.replace(/^\.\/(.*)\.json$/, '$1')
    messages.thai[name] = thaiFiles(key)
  })

  return messages
}

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en',
  messages: loadMessages()
})

export default i18n